const rules = {
    sku: 'required|min:1|max:45',
    quantity: 'required_num|min_value:1|max:9|decimal:0',
};

export {
    rules,
};

export default {
    rules,
};
